/**
 * Hosts that reach the API and return from sign-in on their own origin, so a brand site
 * never shows another brand's domain (for example Lenvoy on lenvoy.co).
 *
 * Set `REACT_APP_OWN_ORIGIN_HOSTS=lenvoy.co,www.lenvoy.co`. Unset, nothing changes.
 *
 * Before a host is listed, both of these must already be in place, or the site cannot
 * load data or sign in:
 *  1. Its Nginx proxies `/graphql` to the API (`continiousDeployment/nginx-lenvoy.conf`).
 *  2. The Cognito app client lists `https://<host>/auth/callback` as a callback URL and
 *     `https://<host>` as a sign-out URL.
 */
export function usesOwnOrigin(hostname: string = window.location.hostname): boolean {
  const configured = (process.env.REACT_APP_OWN_ORIGIN_HOSTS || '')
    .split(',')
    .map(host => host.trim().toLowerCase())
    .filter(Boolean);
  return configured.includes(hostname.toLowerCase());
}
